import { jsx as _jsx } from "react/jsx-runtime";
import { Navigate } from 'react-router-dom';
import { isProd } from '@/config';
import { CodeEntry, ContactSite, Dashboard, Help, Identity, LanguageSelection, LensSubmitted, Login, NotFound, PasswordForgot, PasswordReset, Payment, PaymentSetup, Profile, Questionnaire, Register, Screen, TimeWarp, Tools, Unsupported } from '@/pages';
import LightReport from '@/pages/LightReport';
import LightReportDetail from '@/pages/LightReportDetail';
import { APP_CONFIG, ROUTE } from '@/types';
export const CONFIG_NAVIGATION_TO_ROUTE = {
    [APP_CONFIG.COMPONENTS.PredefinedScreen.DASHBOARD]: ROUTE.DASHBOARD,
    [APP_CONFIG.COMPONENTS.PredefinedScreen.PAYMENT]: ROUTE.PAYMENT,
    [APP_CONFIG.COMPONENTS.PredefinedScreen.PAYMENT_SETUP]: ROUTE.PAYMENT_SETUP,
    [APP_CONFIG.COMPONENTS.PredefinedScreen.PROFILE]: ROUTE.PROFILE,
    [APP_CONFIG.COMPONENTS.PredefinedScreen.QUESTIONNAIRE_FEED]: ROUTE.DASHBOARD,
    [APP_CONFIG.COMPONENTS.PredefinedScreen.SCHEDULE]: ROUTE.DASHBOARD,
    [APP_CONFIG.COMPONENTS.PredefinedScreen.TELEHEALTH]: ROUTE.HOME
};
const generateRoutesFromConfig = (config) => {
    return config.map((route) => (Object.assign(Object.assign({ requireAuth: false, title: '' }, route), { settings: Object.assign({ breadcrumb: {
                display: false
            }, footer: {
                display: true
            }, header: {
                display: true
            } }, route === null || route === void 0 ? void 0 : route.settings) })));
};
const routesConfig = {
    authenticated: [
        {
            element: _jsx(Dashboard, {}),
            path: ROUTE.DASHBOARD,
            requireAuth: true,
            title: 'app:components.navigation.dashboard'
        },
        {
            element: _jsx(Payment, {}),
            path: ROUTE.PAYMENT,
            requireAuth: true,
            settings: {
                breadcrumb: {
                    display: true
                }
            },
            title: 'app:components.navigation.payment'
        },
        {
            element: _jsx(PaymentSetup, {}),
            path: ROUTE.PAYMENT_SETUP,
            requireAuth: true,
            settings: {
                breadcrumb: {
                    display: true,
                    parents: [
                        {
                            path: ROUTE.PAYMENT,
                            title: 'app:components.navigation.payment'
                        }
                    ]
                }
            },
            title: 'app:components.navigation.payment_setup'
        },
        {
            element: _jsx(Help, {}),
            path: ROUTE.HELP,
            requireAuth: true,
            settings: {
                breadcrumb: {
                    display: true
                }
            },
            title: 'app:components.navigation.help_title'
        },
        {
            element: _jsx(Profile, {}),
            path: ROUTE.PROFILE,
            requireAuth: true,
            settings: {
                breadcrumb: {
                    display: true
                }
            },
            title: 'app:components.navigation.profile'
        },
        {
            element: _jsx(Questionnaire, {}),
            path: ROUTE.QUESTIONNAIRE,
            requireAuth: true,
            settings: {
                breadcrumb: {
                    display: true
                },
                footer: {
                    display: false
                }
            }
        },
        {
            element: _jsx(Screen, {}),
            path: ROUTE.SCREEN,
            requireAuth: true,
            settings: {
                breadcrumb: {
                    display: true
                }
            }
        },
        {
            element: _jsx(LightReport, {}),
            path: ROUTE.LIGHT_REPORT_LIST,
            requireAuth: true,
            settings: {
                breadcrumb: {
                    display: true
                },
                footer: {
                    display: false
                }
            }
        },
        {
            element: _jsx(LightReportDetail, {}),
            path: ROUTE.LIGHT_REPORT_DETAIL,
            requireAuth: true,
            settings: {
                breadcrumb: {
                    display: true
                },
                footer: {
                    display: false
                }
            }
        },
        ...(!isProd
            ? [
                {
                    element: _jsx(Tools, {}),
                    path: ROUTE.TOOLS,
                    requireAuth: true,
                    settings: {
                        breadcrumb: {
                            display: true
                        }
                    },
                    title: 'page:tool.title'
                },
                {
                    element: _jsx(TimeWarp, {}),
                    path: ROUTE.TIME_WARP,
                    requireAuth: true,
                    settings: {
                        breadcrumb: {
                            display: true,
                            parents: [
                                {
                                    path: ROUTE.TOOLS,
                                    title: 'page:tool.title'
                                }
                            ]
                        }
                    },
                    title: 'page:tool.time-warp.title'
                }
            ]
            : [])
    ],
    clinro: [
        {
            element: _jsx(Questionnaire, {}),
            path: ROUTE.LENS_QUESTIONNAIRE
        },
        {
            element: _jsx(LensSubmitted, {}),
            path: ROUTE.LENS_SUBMITTED
        }
    ],
    questionnaire_builder: [
        {
            element: _jsx(Questionnaire, {}),
            path: ROUTE.QUESTIONNAIRE_BUILDER_PREVIEW,
            settings: {
                breadcrumb: {
                    display: false
                },
                footer: {
                    display: false
                },
                header: {
                    display: false
                }
            }
        }
    ],
    unauthenticated: [
        {
            element: _jsx(Identity, {}),
            path: ROUTE.IDENTITY_PROVIDER
        },
        {
            element: _jsx(CodeEntry, {}),
            path: ROUTE.HOME
        },
        {
            element: _jsx(Register, {}),
            path: ROUTE.REGISTER
        },
        {
            element: _jsx(LanguageSelection, {}),
            path: ROUTE.LANGUAGE
        },
        {
            element: _jsx(Login, {}),
            path: ROUTE.LOGIN
        },
        {
            element: _jsx(PasswordForgot, {}),
            path: ROUTE.PASSWORD_FORGOT
        },
        {
            element: _jsx(PasswordReset, {}),
            path: ROUTE.PASSWORD_RESET
        },
        {
            element: _jsx(Unsupported, {}),
            path: ROUTE.UNSUPPORTED
        },
        {
            element: _jsx(ContactSite, {}),
            path: ROUTE.CONTACT_SITE
        },
        {
            element: _jsx(NotFound, {}),
            path: ROUTE.NOT_FOUND
        }
    ]
};
export const authRoutes = routesConfig.authenticated.map((route) => route.path.toString());
export const publicRoutes = routesConfig.unauthenticated.map((route) => route.path.toString());
export const routes = [
    ...generateRoutesFromConfig(Object.values(routesConfig).flat()),
    {
        element: _jsx(Navigate, { to: ROUTE.NOT_FOUND }),
        path: '*'
    }
];
